import { SubpageLayout2018 } from '../subpageLayout';

export default function JudgesCriteria2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="評審準則" page="judges_criteria">
      <div className="para_introduction">
        <h1>評審準則</h1>
        <div className="center_introduction">
          <p className="p1">獎項根據以下五個評審準則：</p>
        </div>
        <div className="criteria_container">
          <div className="criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.3s" data-offset="100">
            <div className="crit_text"><br />裨益和影響<br /><br />[20%]</div>
          </div>
          <div className="criteria_2 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.4s" data-offset="100">
            <div className="crit_text crit_text2">功能<br /><br />[20%]</div>
          </div>
          <div className="criteria_3 criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.5s" data-offset="100">
            <div className="crit_text"><br />市場潛力 / 表現<br /><br />[20%]</div>
          </div>
          <div className="criteria_4 criteria_2 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.6s" data-offset="100">
            <div className="crit_text crit_text2">品質<br /><br />[20%]</div>
          </div>
          <div className="criteria_5 criteria_1 animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.7s" data-offset="100">
            <div className="crit_text"><br />創新和創意<br /><br />[20%]</div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

